import React, { memo } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { COMPONENT_MAP } from "./constants/surveyComponentMap";

function QuestionRenderer({
  question,
  index,
  showValidation,
  onDelete,
  onDuplicate,
  onUpdate
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: question.id
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  const Component = COMPONENT_MAP[question.type];

  if (!Component) {
    return null;
  }

  return (
    <div ref={setNodeRef} style={style}>
      <Component
        question={question}
        index={index}
        showValidation={showValidation}
        dragHandleProps={{
          ...attributes,
          ...listeners
        }}
        onDelete={() => onDelete(question.id)}
        onDuplicate={() => onDuplicate(question)}
        onUpdate={(fields) => onUpdate(question.id, fields)}
      />
    </div>
  );
}

export default memo(QuestionRenderer);